import React from 'react';
import { Link } from 'react-router-dom';
import Seo, { getSiteUrl } from '../components/Seo';
import { getLocalizedPath } from '../i18n/localizedRoutes';
import './BlitzballVsWindBallGuide.css';
import { useI18n } from '../i18n/I18nContext';

const BlitzballVsWindBallGuide = () => {
  const { t, locale } = useI18n();
  const siteUrl = getSiteUrl();
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: t('guide.schemaHeadline'),
    description: t('guide.schemaDescription'),
    author: {
      '@type': 'Organization',
      name: 'YCH-YOYO',
    },
    publisher: {
      '@type': 'Organization',
      name: 'YCH-YOYO',
    },
    mainEntityOfPage: `${siteUrl}${getLocalizedPath('/guides/blitzball-vs-windball', locale)}`,
    inLanguage: locale,
  };

  return (
    <main className="guide-page">
      <Seo
        title={t('guide.seoTitle')}
        description={t('guide.seoDescription')}
        path="/guides/blitzball-vs-windball"
        image="/images/Wind Ball/Clear.jpg"
        structuredData={articleSchema}
      />

      <h1>{t('guide.title')}</h1>
      <p>{t('guide.intro')}</p>

      <section>
        <h2>{t('guide.comparison')}</h2>
        <table className="guide-table">
          <thead>
            <tr>
              <th>{t('guide.dimension')}</th>
              <th>BlitzBall</th>
              <th>Wind Ball</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{t('guide.playFeel')}</td>
              <td>{t('guide.blitzFeel')}</td>
              <td>{t('guide.windFeel')}</td>
            </tr>
            <tr>
              <td>{t('guide.bestFor')}</td>
              <td>{t('guide.blitzBest')}</td>
              <td>{t('guide.windBest')}</td>
            </tr>
            <tr>
              <td>{t('guide.tuning')}</td>
              <td>{t('guide.blitzTuning')}</td>
              <td>{t('guide.windTuning')}</td>
            </tr>
            <tr>
              <td>{t('guide.use')}</td>
              <td>{t('guide.blitzUse')}</td>
              <td>{t('guide.windUse')}</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section>
        <h2>{t('guide.recommendation')}</h2>
        <p>{t('guide.recommendationBody')}</p>
      </section>

      <section>
        <h2>{t('guide.related')}</h2>
        <p>
          <Link to={getLocalizedPath('/store/blitzball-ver-2-0', locale)}>{t('guide.viewBlitz')}</Link>
        </p>
        <p>
          <Link to={getLocalizedPath('/store/wind-ball', locale)}>{t('guide.viewWind')}</Link>
        </p>
      </section>
    </main>
  );
};

export default BlitzballVsWindBallGuide;
